import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const IonicIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="-2.5 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.873 10.726c0.198-0.228 0.319-0.525 0.319-0.85 0-0.717-0.582-1.299-1.299-1.299-0.325 0-0.622 0.12-0.85 0.318-1.549-1.168-3.475-1.861-5.559-1.861-5.101 0-9.252 4.15-9.252 9.252s4.15 9.252 9.252 9.252 9.251-4.15 9.251-9.252c0-2.085-0.693-4.011-1.861-5.559zM13.483 25.226c-4.93 0-8.94-4.011-8.94-8.94s4.011-8.94 8.94-8.94c2.004 0 3.857 0.663 5.349 1.781-0.15 0.212-0.239 0.47-0.239 0.749 0 0.717 0.582 1.299 1.299 1.299 0.279 0 0.537-0.089 0.749-0.239 1.118 1.493 1.781 3.345 1.781 5.35 0 4.93-4.010 8.94-8.94 8.94zM17.26 16.285c0 2.086-1.691 3.777-3.777 3.777s-3.777-1.691-3.777-3.777c0-2.086 1.691-3.777 3.777-3.777s3.777 1.691 3.777 3.777z" />
  </svg>
)
const ForwardRef = forwardRef(IonicIcon)
export { ForwardRef as ReactComponent }
